module.exports = ".lbl-paginator select {\r\n    width: 50px;\r\n    margin: 0 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/past-due-report/past-due-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/past-due-report/past-due-report.component.css
// module chunks = main